import { Text } from "@meditect/medibase-components";

export const SalesCannotRefundSaleWithoutCashRegisterError = () => {
  return (
    <Text>
      Aucune caisse ouverte n'est disponible pour imputer ce remboursement. Ouvrez une caisse, puis réessayez.
    </Text>
  );
};
